module.exports = __webpack_public_path__ + "static/media/materiale-curs.42e2f3e3.jpg";